import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  card: {
    marginTop: '10px',
    marginLeft: '32px',
    width: '100%',
  },
  subTitle: {
    fontSize: '16px',
  },
  text: {
    fontSize: '12px',
    margin: 0,
    fontWeight: 400,
  },
  header: {
    fontWeight: 600,
    fontSize: '14px',
  },
});
